import type { ReceiptTemplate } from '../schema';

export const uspsTemplate: ReceiptTemplate = {
  id: 'usps',
  name: 'USPS Receipt',
  brand: 'USPS',
  description: 'United States Postal Service receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'narrow',
  },
  sections: [
    {
      id: 'usps-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/usps.png',
        logoData: '',
        logoWidth: 120,
        logoHeight: 50,
        businessName: '',
        businessNameFontSize: 18,
        addressLines: [
          'UNITED STATES POSTAL SERVICE',
          'MONSTERVILLE POST OFFICE',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'usps-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'SALE\nUnit: 03  Clerk: 127\n01/04/2026  11:42:18',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'usps-tracking',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Tracking Number:\n9400 1118 2847 2910 1274 82',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: true,
      },
    },
    {
      id: 'usps-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        showPrice: true,
        showTotal: false,
        items: [
          { id: 'usps-item-1', name: 'Priority Mail 2-Day', quantity: '1', price: '9.45'},
          { id: 'usps-item-2', name: 'Insurance $100', quantity: '1', price: '3.45'},
          { id: 'usps-item-3', name: 'Delivery Confirm', quantity: '1', price: '0.00'},
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'usps-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 35,
        labelAlignment: 'left',
        lines: [
          { id: 'usps-subtotal', label: 'Subtotal', value: '12.90', isBold: false, isLarge: false },
          { id: 'usps-total', label: 'TOTAL', value: '12.90', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 20,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'usps-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'usps-card', label: 'DEBIT', value: '************4144' },
          { id: 'usps-auth', label: 'Auth', value: '847291' },
        ],
        cashFields: [],
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'usps-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: '94001118284729',
        showValue: true,
        width: 1.2,
        height: 45,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'usps-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Track at usps.com\nor call 1-800-ASK-USPS\n\nThank you for using USPS!',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};

